import * as type from './mutation-type';
import { getPay } from '@/api';

const SITE_CONFIG_CACHE_KEY = 'siteConfigCache';

export default {

  /**
   * 加载站点配置（后台 tb_setting）
   * 优先从 localStorage 读取缓存值立即渲染，再从后端拉取最新值更新缓存
   */
  async loadSiteConfig ({ commit }) {
    // 1. 先用本地缓存值渲染，避免 logo/标题闪烁
    try {
      const cached = localStorage.getItem(SITE_CONFIG_CACHE_KEY);
      if (cached) {
        const parsed = JSON.parse(cached);
        commit(type.SET_SITE_CONFIG, parsed);
      }
    } catch (e) {}

    // 2. 从后端拉取最新值并更新缓存
    try {
      const res = await getPay();
      const data = res.data || {};
      commit(type.SET_SITE_CONFIG, data);
      try {
        localStorage.setItem(SITE_CONFIG_CACHE_KEY, JSON.stringify(data));
      } catch (e) {}
      return data;
    } catch (e) {
      commit(type.SET_SITE_CONFIG, {});
      return {};
    }
  },

};



// WEBPACK FOOTER //
// ./src/store/actions.js